import { connect } from 'react-redux';
import InformationLetter from '../../../views/Personnel/Letter/InformationLetter.letter.view';
import { getInformationLetter, deleteInformationLetter, unpostingInformationLetter } from '../../../states/thunks/personnel.thunk';
import { getDataListSK,getDataPegawai } from '../../../states/thunks/sk.thunks';
function mapStateToProps(state) {
  return {
    result: state.result,
    user: state.user,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    handleGetInformationLetter: payload => dispatch(getDataListSK(payload)),
    handleGetDataPegawai : payload => dispatch(getDataPegawai(payload)),
    // handleDeleteInformationLetter: payload => dispatch(deleteInformationLetter(payload)),
    handleUnpostingInformationLetter: (payload,goBack) => dispatch(unpostingInformationLetter(payload,goBack)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InformationLetter);
